<app-sidebar></app-sidebar>

<div class="main-content">
  <app-license-status-bar></app-license-status-bar>
  <div class="header">

  </div>

  <div class="container-fluid">
    <router-outlet></router-outlet>
  </div>
</div>

<app-right-sidebar></app-right-sidebar>